// frontend/src/components/Configuracion.jsx

import React, { useEffect, useState } from "react";
import {
  Card,
  Input,
  Button,
  Typography,
  Space,
  message,
  Form
} from "antd";
import { SaveOutlined } from "@ant-design/icons";
import axios from "axios";

const { Title } = Typography;

export default function Configuracion() {
  const [form] = Form.useForm();
  const [cargando, setCargando] = useState(false);

  const cargarConfiguracion = async () => {
    try {
      const res = await axios.get("/api/global-config");
      const auth = res.data?.auth || {};
      form.setFieldsValue({
        tenantId: auth.tenantId || "",
        clientId: auth.clientId || "",
        clientSecret: auth.clientSecret || "",
        authority: auth.authority || `https://login.microsoftonline.com/${auth.tenantId}`,
        scopes: (auth.scopes || []).join(", ")
      });
    } catch (err) {
      console.error("Error al cargar configuración global", err);
      message.error("❌ No se pudo cargar la configuración.");
    }
  };

  const guardarConfiguracion = async () => {
    try {
      const values = await form.validateFields();
      const payload = {
        type: "graph",
        auth: {
          tenantId: values.tenantId.trim(),
          clientId: values.clientId.trim(),
          clientSecret: values.clientSecret.trim(),
          authority: values.authority.trim(),
          scopes: values.scopes.split(",").map((s) => s.trim())
        }
      };
      setCargando(true);
      await axios.post("/api/global-config", payload);
      message.success("✅ Configuración guardada correctamente.");
    } catch (err) {
      console.error("Error al guardar configuración global", err);
      message.error("❌ Error al guardar configuración.");
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    cargarConfiguracion();
  }, []);

  return (
    <div style={{ padding: "0rem 1rem 1rem", maxWidth: 1000, margin: "0 auto" }}>
      <Title level={3}>⚙️ Configuración Global</Title>

      <Card>
        <Form
          form={form}
          layout="vertical"
          onFinish={guardarConfiguracion}
          autoComplete="off"
        >
          <Form.Item
            label="Tenant ID"
            name="tenantId"
            rules={[{ required: true, message: "Campo requerido" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Client ID"
            name="clientId"
            rules={[{ required: true, message: "Campo requerido" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Client Secret"
            name="clientSecret"
            rules={[{ required: true, message: "Campo requerido" }]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item
            label="Authority"
            name="authority"
            rules={[{ required: true, message: "Campo requerido" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Scopes (separados por coma)"
            name="scopes"
            rules={[{ required: true, message: "Campo requerido" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button
                type="primary"
                htmlType="submit"
                icon={<SaveOutlined />}
                loading={cargando}
              >
                Guardar configuración
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
